import React, { useEffect, useRef } from 'react';

import { Close } from '$partials/icons/index.js';
import { useKeyboard } from '$hooks/events';
import { useNavigation } from '$contexts/navigation.jsx';
import Button from '$partials/ui/button.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Navigation = () => {
    const {
        backgroundColour,
        close,
        isOpen,
        links,
        textColour
    } = useNavigation();

    const dialogRef = useRef();

    useKeyboard({
        'Escape': (e) => {
            e.preventDefault();
            isOpen && close();
        }
    }, [isOpen]);

    useEffect(() => {
        const dialogNode = dialogRef.current;
        if (isOpen) {
            if (dialogNode && !dialogNode.open) {
                dialogNode.showModal?.();
            }
        } else {
            if (dialogNode && dialogNode.open) {
                dialogNode.close?.();
            }
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <dialog
            className='dialog-reset'
            onClick={() => close()}
            ref={dialogRef}>
            <div
                className={isOpen ? 'primary-navigation__container' : 'hidden'}
                onClick={(e) => e.stopPropagation()}>
                <style dangerouslySetInnerHTML={{
                    __html: `
                        .primary-navigation__modal {
                            --background: ${backgroundColour};
                            --foreground: ${textColour};
                        }
                    `}} />

                <nav
                    aria-label='Primary navigation'
                    className='primary-navigation__modal'>
                    <ul className='flex flex-col sm:flex-row flex-reverse gap-[3px]'>
                        <li key='close'>
                            <Button
                                aria-label='Close primary navigation menu'
                                className='primary-navigation__button'
                                id='primary-navigation-close'
                                onClick={() => close()}
                                type='button'>
                                <Close />
                            </Button>
                        </li>
                        {links?.map((link, i) => {
                            return (
                                <li key={i}>
                                    <a
                                        className='block h-[48px] leading-[48px] px-[30px] rounded-[24px] bg-background text-foreground hover:bg-foreground hover:text-background'
                                        href={link.url}>
                                        {link.title}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </dialog>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {};
Navigation.propTypes = propTypes;

export default Navigation;
